import React from "react";
import { RevealOnMount } from "src/components/reveal-on-mount";
import { SEO } from "src/components/SEO";
import { MetaInfo } from "src/types/meta";
import { ClientsList } from "src/components/clients-list";

export interface ClientsProps {
	data: {
		main: {
			slug: {
				current: string;
			};
			title: string;
		};
		meta: {
			metaTitle?: string;
			metaDescription?: string;
			openImage?: any;
			twitterImage?: any;
		};
	};
	location: any;
}

const ClientsTemplate = ({ location, data }: ClientsProps) => {
	const { main, meta } = data;

	// set fallback meta tags from content
	const metaInfo: MetaInfo = {
		metaTitle: meta?.metaTitle || main.title,
		metaDescription: meta?.metaDescription,
		openImage: meta?.openImage,
		twitterImage: meta?.twitterImage || meta?.openImage,
	};

	return (
		<RevealOnMount location={location}>
			<SEO
				metaInfo={metaInfo}
				pagePath={location?.pathname}
				slug={main.slug.current}
			/>
			<ClientsList data={main} />
		</RevealOnMount>
	);
};

export default ClientsTemplate;
